import _ from 'underscore';
import React from 'react';
import { layoutConfigs } from './layout-configs';
import { ILayoutContext } from './types';

export const LayoutContext = React.createContext<ILayoutContext>({
  config: layoutConfigs.default,
  change: _.noop,
});
